module.exports = __webpack_public_path__ + "img/5.9a114fb6.jpg";